/**
 * Capas GeoJSON BMP (src/assets/layers/bmp/*.geojson).
 * Usado por Visor, QueryBuilder y ejecución de consultas.
 */

const bmpUrlModules = import.meta.glob<string>(
  '../assets/layers/bmp/*.geojson',
  { eager: true, query: '?url', import: 'default' }
)

const BMP_LIMITE_LAYER_ID = 'BMP_unido6'

function layerDisplayName(fileName: string): string {
  if (fileName === BMP_LIMITE_LAYER_ID) return 'Límite BMP'
  let s = fileName.replace(/_/g, ' ')
  s = s.replace(/\bBMP\b/gi, ' ').replace(/\s+/g, ' ').trim()
  return s || fileName.replace(/_/g, ' ')
}

export const BMP_LAYER_PREFIX = 'bmp:'

export interface BmpLayerInfo {
  id: string
  displayName: string
  url: string
}

const bmpLayersAll = Object.entries(bmpUrlModules)
  .map(([path, mod]) => {
    const name = path.split('/').pop()?.replace(/\.geojson$/i, '') ?? path
    const url = typeof mod === 'string' ? mod : (mod as any)?.default ?? ''
    return { id: name, displayName: layerDisplayName(name), url }
  })
  .filter((l) => l.url)

const limite = bmpLayersAll.find((l) => l.id === BMP_LIMITE_LAYER_ID)
const otros = bmpLayersAll
  .filter((l) => l.id !== BMP_LIMITE_LAYER_ID)
  .sort((a, b) => a.displayName.localeCompare(b.displayName, 'es', { sensitivity: 'base' }))

const bmpLayersList: BmpLayerInfo[] = limite ? [limite, ...otros] : bmpLayersAll

export function getBmpLayersList(): BmpLayerInfo[] {
  return bmpLayersList
}

export function getBmpLayerUrl(id: string): string | null {
  const layer = bmpLayersList.find((l) => l.id === id)
  return layer?.url ?? null
}

export function getBmpLayerById(id: string): BmpLayerInfo | null {
  return bmpLayersList.find((l) => l.id === id) ?? null
}

/** baseTable value para usar en QueryBuilder/config cuando la fuente es una capa BMP */
export function bmpBaseTableValue(layerId: string): string {
  return `${BMP_LAYER_PREFIX}${layerId}`
}

export function isBmpBaseTable(baseTable: string): boolean {
  return baseTable.startsWith(BMP_LAYER_PREFIX)
}

export function getBmpLayerIdFromBaseTable(baseTable: string): string | null {
  if (!isBmpBaseTable(baseTable)) return null
  return baseTable.slice(BMP_LAYER_PREFIX.length)
}
